import React from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import AttachmentManager from './AttachmentManager';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';

const attachmentContainers = document.querySelectorAll('[data-attachment-manager]');

attachmentContainers.forEach((container) => {
    const fetchUrl = container.dataset.fetchUrl;
    const storeUrl = container.dataset.storeUrl;
    const updateUrl = container.dataset.updateUrl;
    const deleteUrl = container.dataset.deleteUrl;
    const downloadUrl = container.dataset.downloadUrl;
    const acceptedFileTypes = container.dataset.acceptedFileTypes;
    const channelName = container.dataset.channelName;

    const routes = {
        fetch: fetchUrl,
        store: storeUrl,
        update: updateUrl,
        delete: deleteUrl,
        download: downloadUrl,
    };

    if (routes.fetch) {
        ReactDOM.render(
            <App>
                <ConfirmationModalProvider>
                    <AttachmentManager routes={routes} acceptedFileTypes={acceptedFileTypes} channelName={channelName} />
                </ConfirmationModalProvider>
            </App>,
            container,
        );
    }
});
